import { __generator } from "tslib";
import { put, call, all, takeEvery, select, race, take, } from 'redux-saga/effects';
import { request } from '../../xhr';
import { pushModal, confirmYes, confirmNo, } from '../../Modals/redux/actionCreators';
import { actions as notificationActions, NotificationType, } from '../../Notifications';
import ErrorIcon from '@wix/da-ds/pkg/Icons/24x24/Error';
import { deletePortfolio, deletePortfolioSuccess, toggleFeedbackPage, openNotificationsDropdown, } from './actions';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { ModalType } from '../../Modals/redux/types';
import { exitDuperbrowse, openDuperbrowse, } from '../../Duperbrowse/redux/actionCreators';
import { FEEDBACK_PAGE_DUPERBROWSE_ITEMID, FEEDBACK_PAGE_DUPERBROWSE_STREAMID, } from '../../Duperbrowse/redux/constants';
import { getIsFeedbackPageOpen } from './selectors';
import { logBiEvent } from '../../biLogger/redux/saga';
function handleDeletePortfolio() {
    var no, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(pushModal(ModalType.WIX_PORTFOLIO_DELETE, {}))];
            case 1:
                _a.sent();
                return [4 /*yield*/, race({
                        yes: take(confirmYes),
                        no: take(confirmNo),
                    })];
            case 2:
                no = (_a.sent()).no;
                if (no) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/wix_portfolio/delete',
                    }, function () { return ({ success: true }); })];
            case 3:
                result = _a.sent();
                if (!result.success) return [3 /*break*/, 6];
                // this is picked up in publicSession and makes hasWixPortfolio false
                return [4 /*yield*/, put(deletePortfolioSuccess())];
            case 4:
                // this is picked up in publicSession and makes hasWixPortfolio false
                _a.sent();
                return [4 /*yield*/, put(pushModal(ModalType.WIX_PORTFOLIO_CREATE, { wrapInModal: false }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(notificationActions.addNotification(NotificationType.Generic, {
                    messageLocaleKey: 'common.somethingWentWrong',
                    cardProps: { iconComponent: ErrorIcon },
                }))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
function handleOpenNotificationDropdown() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // not using logPageView here because this is a fake pageview event and we
            // should avoid the side effects running
            return [4 /*yield*/, call(logBiEvent, PureBiData({
                    evid: 99,
                    view: 'notifications',
                    component: 'header',
                }))];
            case 1:
                // not using logPageView here because this is a fake pageview event and we
                // should avoid the side effects running
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleToggleFeedbackPage() {
    var isOpen;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsFeedbackPageOpen)];
            case 1:
                isOpen = _a.sent();
                if (!isOpen) return [3 /*break*/, 3];
                return [4 /*yield*/, put(exitDuperbrowse())];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(openDuperbrowse(FEEDBACK_PAGE_DUPERBROWSE_ITEMID, {
                    streamId: FEEDBACK_PAGE_DUPERBROWSE_STREAMID,
                    items: [FEEDBACK_PAGE_DUPERBROWSE_ITEMID],
                }))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(deletePortfolio, handleDeletePortfolio),
                    takeEvery(openNotificationsDropdown, handleOpenNotificationDropdown),
                    takeEvery(toggleFeedbackPage, handleToggleFeedbackPage),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map